import { DEVICES_TYPES } from "app/reducers/devicesSlice";
import { Headset } from "interfaces/Device";
import { HeadsetStatus } from "ui";
import { TableRow } from "ui/Table";
import { dateFormatter, FORMATTER_OPTIONS } from "utils/dates";

type Props = {
  headset: Headset;
};

export const DevicesTableBodyRow = ({ headset }: Props) => {
  return (
    <TableRow key={`device-table-row-${headset._id}`}>
      <td className="flex justify-center py-2 pl-2 align-center">
        <p className="text-faux-gainsboro">{headset.description}</p>
      </td>
      <td className="text-center capitalize text-faux-gainsboro">
        {DEVICES_TYPES.HEADSET}
      </td>
      <td className=" flex justify-center py-2 pl-2 align-center">
        <HeadsetStatus
          isConnected={!!headset.connectionId}
          batteryValue={headset.battery}
        />
      </td>
      <td className="pr-2">
        <p className="flex justify-center text-faux-gainsboro align-center">
          {dateFormatter(
            new Date(headset.updatedAt),
            FORMATTER_OPTIONS.player_table,
          )}
        </p>
      </td>
    </TableRow>
  );
};
